import styled, { createGlobalStyle } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  * {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-family: 'Source Sans Pro', sans-serif;
 } 
`;

export const Container = styled.div`
  z-index: 1;
  width: 100%;
  max-width: 1300px;
  margin-right: auto;
  margin-left: auto;
  padding-right: 50px;
  padding-left: 50px;

  @media screen and (max-width: 991px) {
    padding-right: 30px;
    padding-left: 30px;
  }
`;

export const Button = styled.button`
  border-radius: 10px;
  background: ${({ primary }) => (primary ? 'linear-gradient(135deg, #4b59f7 0%, #0467fb 100%)' : 'linear-gradient(135deg, #334155 0%, #1e293b 100%)')};
  white-space: nowrap;
  padding: ${({ big }) => (big ? '14px 48px' : '12px 28px')};
  color: #fff;
  font-size: ${({ fontBig }) => (fontBig ? '18px' : '15px')};
  font-weight: 600;
  outline: none;
  border: none;
  cursor: pointer;
  box-shadow: ${({ primary }) => (primary ? '0 4px 15px rgba(75, 89, 247, 0.25)' : '0 4px 15px rgba(0, 0, 0, 0.15)')};
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    transform: translateY(-2px);
    box-shadow: ${({ primary }) => (primary ? '0 6px 20px rgba(75, 89, 247, 0.35)' : '0 6px 20px rgba(0, 0, 0, 0.25)')};
    background: ${({ primary }) => (primary ? 'linear-gradient(135deg, #5c6aff 0%, #1e7aff 100%)' : 'linear-gradient(135deg, #475569 0%, #334155 100%)')};
  }

  &:active {
    transform: translateY(0);
  }

  @media screen and (max-width: 960px) {
    width: 100%;
  }
`;

export default GlobalStyle;
